import React, { Component, Fragment } from 'react'
import Link, { push } from 'gatsby-link'
import styled from 'styled-components'
import Menu from '../../assets/icon/menu.png'

// import NavigationItem from '../components/navigation-item'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.96);
  width: 100vw;
  height: 100vh;
  color: gray;
  justify-content: space-evenly;
  align-items: space-evenly;
  padding-top: 10vh;
  z-index: 10;
  pointer-events: none;
`
const NavigationItem = styled.div`
  // margin-top: 5vw;
  // padding-top: 5vh;
  // padding-bottom: 5vh;
  text-align: center;
  width: auto;
  font-size: 3.5vw;
  font-family: OpensansBold;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: gray;
  pointer-events: auto;
`

const Lang = styled(NavigationItem)``

class Navigation extends Component {
  state = {
    items: [
      {
        label: 'Projetos',
        label_en: 'Projects',
        link: '/projetos',
        marked: false
      },
      {
        label: 'Escritório',
        label_en: 'Studio',
        link: '/escritorio',
        marked: false
      },
      { label: 'Memória', label_en: 'Memory', link: '/memoria', marked: false },
      { label: 'Acervo', label_en: 'Archive', link: '/acervo', marked: false },
      {
        label: 'Contato',
        label_en: 'Contact',
        link: '/contato',
        marked: false
      }
    ],
    pathname: '',
    language: '',
    open: false
  }

  componentDidMount () {
    if (window) {
      const { pathname } = window.location
      let items = this.state.items
      items.map(item => {
        item.marked = (item.link == '/projetos' && pathname.indexOf('/projeto') !== -1) || item.link === pathname
      })
      this.setState({ items, pathname: pathname })

      if (window.location.search) {
        this.setState({ language: window.location.search })
      }
    }
  }

  componentWillUpdate () {
    if (window) {
      const { pathname } = window.location
      if (this.state.pathname !== pathname) {
        let items = this.state.items
        items.map(item => {
          item.marked = (item.link == '/projetos' && pathname.indexOf('/projeto') !== -1) || item.link === pathname
        })
        this.setState({ items, pathname: pathname })
      }
    }
  }

  _change = lang => {
    window.location.href = lang == 'en' ? `${window.location.pathname}?lang=en` : window.location.pathname
  }

  _navigate = (uri, index) => {
    let items = this.state.items
    items.map((item, itemIndex) => {
      item.marked = itemIndex === index
    })
    this.setState({ items })
    push(uri)
  }

  render () {
    const { items, open } = this.state
    return (
      <Fragment>
        {open && (
          <Wrapper>
            {items.map((item, index) => (
              <NavigationItem
                key={index}
                label={this.state.language === '?lang=en' ? item.label_en : item.label}
                marked={item.marked}
                tone={this.props.tone}
                onClick={() => {
                  this.setState({ open: false })
                  setTimeout(() => {
                    this._navigate(`${item.link}${this.state.language}`, index)
                  }, 100)
                }}>
                {this.state.language === '?lang=en' ? item.label_en : item.label}
              </NavigationItem>
            ))}
            <Lang marked={this.state.language === ''} tone={this.props.tone} style={{ marginTop: `40px`, height: `20px` }} onClick={() => this._change('pt')}>
              pt
            </Lang>
            <Lang
              marked={this.state.language === '?lang=en'}
              tone={this.props.tone}
              style={{ marginTop: `0px`, height: `20px` }}
              onClick={() => this._change('en')}>
              en
            </Lang>
          </Wrapper>
        )}
        {!open && (
          <div
            style={{
              position: `fixed`,
              right: 20,
              top: 20,
              width: 30,
              height: 30,
              pointerEvents: `auto`
            }}
            onClick={() => this.setState({ open: true })}>
            <img src={Menu} style={{ width: `100%`, height: `100%` }} />
          </div>
        )}
      </Fragment>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation-mobile.js